import styled from "styled-components";

export const Main = styled.main`
    flex: 1;
    padding: 4rem 2rem 1rem;
    max-width: 1200px;
    margin: 0 auto;
    background-color: #ffffff;
    border-radius: 3px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    position: relative;
    z-index: 1;
    `
